import { c as _c } from "react/compiler-runtime";
import styles from './more-courses-by-instructors.module.scss';
import { LocalizedHtml, useI18n } from '@udemy-v2/i18n';
import { BrowseEventTrackingProvider, BackendSourceOptions, TrackableDiscoveryItem, DiscoveryItemTypeOptions } from '@udemy-v2/react-browse-event-tracking';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { useMoreCoursesByInstructor } from '@/lib/hooks/use-more-courses-by-instructor';
import { BrowseCourseWithInstructorDetails } from '@/types/course';
import { Instructor } from '@udemy-v2/browse-course';
import { ResponsiveBrowseCourseCarousel } from '@/features/course-landing-page/components/browse-course-carousel/responsive-browse-course-carousel.react-component';
export interface MoreCoursesByInstructorProps {
  instructors: Instructor[];
}
export interface MoreCoursesByInstructorsProps {
  instructor: Instructor;
  moreCoursesByInstructor: TrackableDiscoveryItem<BrowseCourseWithInstructorDetails>[];
}
export const MoreCoursesByInstructors = t0 => {
  const $ = _c(7);
  const {
    instructors
  } = t0;
  const coursesByInstructor = useMoreCoursesByInstructor();
  let t1;
  if ($[0] !== coursesByInstructor || $[1] !== instructors) {
    let t2;
    if ($[3] !== coursesByInstructor) {
      t2 = instructor => {
        if (!instructor.url) {
          return null;
        }
        return <MoreCoursesByInstructor key={`MoreCoursesByInstructors-${instructor.url}`} instructor={instructor} moreCoursesByInstructor={coursesByInstructor[instructor.url] ?? []} />;
      };
      $[3] = coursesByInstructor;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = instructors.map(t2);
    $[0] = coursesByInstructor;
    $[1] = instructors;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <>{t1}</>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const MoreCoursesByInstructor = t0 => {
  const $ = _c(22);
  const {
    instructor,
    moreCoursesByInstructor
  } = t0;
  const {
    gettext,
    interpolate
  } = useI18n();
  const course = useClpCourse();
  if (moreCoursesByInstructor.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== moreCoursesByInstructor) {
    t1 = moreCoursesByInstructor.length > 3 ? moreCoursesByInstructor.slice(0, 3) : moreCoursesByInstructor;
    $[0] = moreCoursesByInstructor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const displayedCourses = t1;
  const t2 = `MoreCoursesByInstructor-${instructor.url}`;
  let t3;
  if ($[2] !== gettext || $[3] !== instructor.name || $[4] !== interpolate) {
    t3 = interpolate(gettext("More Courses by <a class=\"instructorLink\">%(instructorName)s</a>"), {
      instructorName: instructor.name
    }, true);
    $[2] = gettext;
    $[3] = instructor.name;
    $[4] = interpolate;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== instructor.url) {
    t4 = {
      instructorLink: <a className="ud-heading-xl ud-link-underline" href={instructor.url} />
    };
    $[6] = instructor.url;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <LocalizedHtml html={t3} interpolate={t4} className="ud-heading-xl" />;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== course.id) {
    t6 = {
      relatedSourceId: course.id,
      relatedSourceType: DiscoveryItemTypeOptions.COURSE,
      backendSource: BackendSourceOptions.TAUGHT_COURSES
    };
    $[11] = course.id;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== displayedCourses) {
    t7 = <ResponsiveBrowseCourseCarousel courses={displayedCourses} className={styles["margin-top-xs"]} />;
    $[13] = displayedCourses;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <BrowseEventTrackingProvider browseEventTrackingContext={t6}>{t7}</BrowseEventTrackingProvider>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t5 || $[20] !== t8) {
    t9 = <div key={t2} className={styles["margin-top-xs"]}>{t5}{t8}</div>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};